import React, {FC, useEffect, useState} from 'react';
import {useLocation} from '@reach/router';
import {Link} from 'gatsby';

type ReloadLinkProps = {
 to: string
 children?: React.ReactNode
 className?: string
}

const ReloadLink: FC<ReloadLinkProps> = ({to, children, className}) => {
	const {pathname, search, hash} = useLocation();
	const [check, setCheck] = useState<string>();

	useEffect(() => {
		setCheck(pathname + search + hash);
	}, [pathname, search, hash]);

	if (check === to) {
		return (
			<a href={to} className={className}>
				{children}
			</a>
		);
	}

	return (
		<Link to={to} className={className}>
			{children}
		</Link>
	);
};

export default ReloadLink;

